import React, { useState, useRef, useContext } from 'react';
import axios from 'axios';
import { useLocation, useParams } from 'react-router-dom';
import './FeedbackOverlay.css';
import { UserContext, WorkspaceContext } from '../../objects/Context';
import shortId from 'short-uuid';

const FeedbackOverlay = ({ onClose }) => {
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { user } = useContext(UserContext);
  const { workspace } = useContext(WorkspaceContext);
  const location = useLocation();
  const params = useParams();
  const overlayRef = useRef(null);

  const getPageInfo = () => {
    const path = location.pathname;
    const search = location.search;
    const pageInfo = {
      path,
      search,
      params
    };

    // Add specific page information based on the current route
    if (path.startsWith('/report/')) {
      pageInfo.type = 'Report';
      pageInfo.id = params.taskId;
    } else if (path.startsWith('/insights/')) {
      pageInfo.type = 'Insight';
      pageInfo.id = params.insightId;
    } else if (path.startsWith('/dashboards/')) {
      pageInfo.type = 'Dashboard';
      pageInfo.id = params.dashboardId;
    } else if (path.startsWith('/forecast')) {
      pageInfo.type = 'Thread';
      pageInfo.id = new URLSearchParams(search).get('thread');
    }

    return pageInfo;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setIsSubmitting(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/feedback/save-feedback`, {
        parentId: "UNKNOWN_" + shortId.generate(),
        parentType: getPageInfo().type || 'unknown',
        text: message,
        userId: user.id,
        workspaceId: workspace.id,
        createdAt: new Date().toISOString()
      }, { withCredentials: true });
      setIsSubmitted(true);
    } catch (error) {
      console.error('Failed to send feedback:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="feedback-overlay">
      <div className="feedback-overlay-content" ref={overlayRef}>
        <h2>Share Feedback</h2>
        {isSubmitted ? (
          <div className="feedback-thankyou">
            <div>Thanks for sharing your feedback!</div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your message here..."
              rows={6}
            />
            <div className="feedback-actions">
              <button type="button" onClick={onClose} className="cancel-button">
                Cancel
              </button>
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackOverlay; 